import { useState, useEffect, useRef } from "react";
import "../assets/css/applyLoan.css";
import logo from "../assets/img/toedit.png";

import { useParams } from "react-router-dom";


const LOAN_SETTINGS_API = `${process.env.REACT_APP_API_BASE}/loans/loan_settings.php`;

const RUNNING_LOAN_API = `${process.env.REACT_APP_API_BASE}/loans/check_running_loan.php`;

/* ===============================
   UPLOAD LABELS
=============================== */
const UPLOAD_LABELS = {
  passport: "Passport Photograph",
  id_card: "Official Identification Card",
  payslip: "Last Month Payslip (Compulsory)",
bank_statement: "Bank Statement",
  consent_form: "Signed Consent Form", 
  asset_photo: "Asset Photograph",
  business_docs: "Business Documents",
  signature: "Signature",
};

const NIGERIAN_BANKS = [
  "Access Bank",
  "Citibank",
  "Ecobank",
  "Fidelity Bank",
  "First Bank of Nigeria",
  "First City Monument Bank (FCMB)",
  "Globus Bank",
  "Guaranty Trust Bank (GTBank)",
  "Heritage Bank",
  "Keystone Bank",
  "Polaris Bank",
  "Providus Bank",
  "Stanbic IBTC Bank",
  "Standard Chartered Bank",
  "Sterling Bank",
  "SunTrust Bank",
  "Union Bank",
  "United Bank for Africa (UBA)",
  "Unity Bank",
  "Wema Bank",
  "Zenith Bank",
  "Opay",
  "Palmpay",
  "Kuda Bank",
  "Moniepoint"
];
/* ===============================
   REUSABLE UPLOAD FIELD
=============================== */
function UploadField({
  label,
  name,
  required,
  accept,
  value,
  onChange,
  withCamera = false,
}) {
  const inputRef = useRef(null);
  const cameraRef = useRef(null);

  // ✅ Preview state (belongs here, not in ApplyLoan)
  const [preview, setPreview] = useState(null);

  // ✅ Generate preview when image selected
  useEffect(() => {
    if (!value) {
      setPreview(null);
      return;
    }

    if (value.type?.startsWith("image/")) {
      const objectUrl = URL.createObjectURL(value);
      setPreview(objectUrl);

      // Cleanup to prevent memory leaks
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(null);
    }
  }, [value]);

  return (
    <div className={`upload-card ${value ? "has-file" : ""}`}>
      <div className="upload-title">
        {label} {required && <span className="required">*</span>}
      </div>

      <div className="upload-sub">
        {value
          ? `${value.name} (${Math.round(value.size / 1024)} KB)`
          : "Upload 1 supported file. Max 10 MB."}
      </div>

      {/* 🖼 Image Preview */}
      {preview && (
        <div className="upload-preview">
          <img
            src={preview}
            alt="preview"
            style={{
              width: "100%",
              maxHeight: "180px",
              objectFit: "cover",
              marginTop: "10px",
              borderRadius: "8px",
            }}
          />
        </div>
      )}

      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {/* 📁 Upload Button */}
        <button
          type="button"
          className="upload-btn"
          onClick={() => inputRef.current.click()}
        >
          ⬆ {value ? "Change file" : "Upload"}
        </button>

        {/* 📸 Camera Button */}
        {withCamera && (
          <button
            type="button"
            className="upload-btn camera-btn"
            onClick={() => cameraRef.current.click()}
          >
            📸 Snap
          </button>
        )}
      </div>

      {/* Normal Upload */}
      <input
        ref={inputRef}
        type="file"
        name={name}
        accept={accept}
        hidden
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            onChange({
              target: {
                name,
                value: file,
              },
            });
          }
        }}
        required={required && !value}
      />

      {/* Camera Capture */}
      {withCamera && (
        <input
          ref={cameraRef}
          type="file"
          accept="image/*"
          capture="environment"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              onChange({
                target: {
                  name,
                  value: file,
                },
              });
            }
          }}
        />
      )}
    </div>
  );
}










export default function ApplyLoan() {


  

const IMAGE_UPLOADS = [
  "passport",
  "id_card",
  "asset_photo",
  "signature",
  "payslip",   // 👈 ADD THIS
   "consent_form" 
];



    const { employeeNo } = useParams();



const maskNumber = (v) =>
  v ? v.replace(/\d(?=\d{4})/g, "*") : "";

    const isPhone = (v) => /^\d{11}$/.test(v);
const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

const isAdult = (dob) => {
  if (!dob) return false;
  const birth = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age >= 18;
};

  const [step, setStep] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [loanProducts, setLoanProducts] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [trackingId, setTrackingId] = useState("");
const [checkingLoan, setCheckingLoan] = useState(false);
const [runningLoan, setRunningLoan] = useState(null);
const [showRunningLoanModal, setShowRunningLoanModal] = useState(false);
const [runningLoanProceed, setRunningLoanProceed] = useState(false);

const [submitting, setSubmitting] = useState(false);

const fetchLoanProducts = async () => {
  try {
    const res = await fetch(LOAN_SETTINGS_API, {
      method: "GET",
      credentials: "include",
    });

    const data = await res.json();

    if (data.success) {
      setLoanProducts(data.products || []);
    }
  } catch (err) {
    console.error("Fetch loan products error:", err);
  }
};
useEffect(() => {
  fetchLoanProducts();
}, []);
useEffect(() => {
  if (!employeeNo) return;

 fetch(`${process.env.REACT_APP_API_BASE}/get_employee.php?id=${employeeNo}`)
    .then(res => res.json())
    .then(data => {
      if (!data.success) return;

      setForm(prev => ({
        ...prev,
        account_officer_code: data.data.employee_no,
        account_officer_name: data.data.name,
        account_officer_email: data.data.email,
      }));
    })
    .catch(() => console.error("Invalid employee link"));
}, [employeeNo]);

const initialFormState = {
  first_name: "",
  last_name: "",
  gender: "", 
  dob: "",
  phone: "",
  other_phone: "",
  email: "",
  bvn: "",
  nin: "",
  address: "",
  state_of_origin: "",
  next_of_kin: "",
  nok_phone: "",

  employer: "",
  ippis_number: "",
  date_of_employment: "",
  grade_level: "",

  business_name: "",
  business_address: "",
  rc_number: "",

  loan_amount: "",
  loan_tenor: "",
  bank_name: "",
  account_number: "",

  passport: null,
  id_card: null,
  bank_statement: null,
  payslip: null,
  consent_form: null, 
  asset_photo: null,
  business_docs: null,
  signature: null,

 

  // officer info
  account_officer_code: null,
  account_officer_name: null,
  account_officer_email: null,

  // system info
  application_time: null,
};

const [form, setForm] = useState(initialFormState);


const runningLoanCalc = runningLoan?.loan
  ? {
      principalBalance: Number(runningLoan.loan.principal_balance || 0),
      interestAmount: Number(runningLoan.loan.interest_amount || 0),
      liquidationFee: Number(runningLoan.loan.liquidation_fee || 0),
      totalPayoff: Number(runningLoan.loan.total_payoff_balance || 0),
      paidMonths: Number(runningLoan.loan.paid_months || 0),
    }
  : null;

const totalPrincipalToSettle = runningLoanCalc
  ? runningLoanCalc.totalPayoff
  : 0;


const requestedLoanAmount = Number(String(form.loan_amount || "0").replace(/,/g, ""));

const selectedProductDetails = loanProducts.find(
  (p) => p.product_name === selectedProduct
);

const minAmount = Number(selectedProductDetails?.min_amount || 0);
const maxAmount = Number(selectedProductDetails?.max_amount || 0);
const minTenure = Number(selectedProductDetails?.min_tenure || 1);
const maxTenure = Number(selectedProductDetails?.max_tenure || 24);
const interestRate = Number(selectedProductDetails?.interest_rate || 0);

const upfrontFeeRate = Number(
  selectedProductDetails?.upfront_fee_rate ??
  selectedProductDetails?.upfrontFeeRate ??
  0
);

const balanceAfterSettlement = Math.max(
  requestedLoanAmount - totalPrincipalToSettle,
  0
);

const upfrontFeeAmount = runningLoanProceed
  ? (balanceAfterSettlement * upfrontFeeRate) / 100
  : 0;

const estimatedDisbursement = Math.max(
  balanceAfterSettlement - upfrontFeeAmount,
  0
);


const estimatedCustomerReceives = runningLoanProceed
  ? estimatedDisbursement
  : requestedLoanAmount;


const productConfig = selectedProduct
  ? {
      label: selectedProduct,
      uploads: selectedProduct && selectedProduct.toUpperCase().includes("IPPIS")
        ? ["passport", "id_card", "payslip", "consent_form", "signature"]
        : ["passport", "id_card", "bank_statement", "consent_form", "signature"],
    }
  : null;

const isTopUp = runningLoanProceed && runningLoan;

const topUpRequiredUploads = ["consent_form"];

const requiredUploads = isTopUp
  ? topUpRequiredUploads
  : productConfig?.uploads || [];


useEffect(() => {
  const shouldLock =
  submitting || showSuccessModal || showConfirmModal || showRunningLoanModal;

  if (shouldLock) {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  };
}, [submitting, showSuccessModal, showConfirmModal, showRunningLoanModal]);


const handleChange = (e) => {
  const { name, value, files } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: files ? files[0] : value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};


const checkRunningLoan = async () => {
  setCheckingLoan(true);

  try {
    const params = new URLSearchParams({
      bvn: form.bvn,
      nin: form.nin,
    });

    const url = `${RUNNING_LOAN_API}?${params.toString()}`;
    console.log("Running loan API:", url);

    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
    });

    const data = await res.json();
    console.log("Running loan response:", data);

    if (data.success === true && data.has_running_loan === true) {
    setRunningLoan(data);

setForm((prev) => ({
  ...prev,
  bank_name: data.loan?.bank_name || "",
  account_number: data.loan?.bank_account || "",
}));

setShowRunningLoanModal(true);
      setStep(1); // keep user on step 1
      return true;
    }

    return false;
  } catch (err) {
    console.error("Running loan check failed:", err);
    alert("Could not check running loan. Please try again.");
    return true; // stop going to step 2 if check fails
  } finally {
    setCheckingLoan(false);
  }
};

const goToNextStep = async (e) => {
  e.preventDefault();

  const newErrors = {};

  if (!selectedProduct)
    newErrors.product = "Please select a loan product";

  if (form.bvn.length !== 11)
    newErrors.bvn = "BVN must be exactly 11 digits";

  if (form.nin.length !== 11)
    newErrors.nin = "NIN must be exactly 11 digits";

  setErrors(newErrors);

  if (Object.keys(newErrors).length === 0) {
    const hasRunningLoan = await checkRunningLoan();

    if (!hasRunningLoan) {
      setRunningLoanProceed(false);
      setStep(2);
    }
  }
};


const handleCloseModal = () => {
  setShowSuccessModal(false);
  setStep(1);
  setTrackingId("");
  setSelectedProduct("");
  setRunningLoan(null);
  setRunningLoanProceed(false);
  setShowRunningLoanModal(false);
  setShowConfirmModal(false);
  setErrors({});
  setForm(initialFormState);
};


const submitLoan = async () => {
  if (submitting) return;

  const newErrors = {};

 

 if (runningLoanProceed && runningLoan) {
  if (!form.loan_amount) newErrors.loan_amount = "Loan amount is required";
  if (!form.loan_tenor) newErrors.loan_tenor = "Select loan tenor";

 if (!form.bank_name) {
    newErrors.bank_name = "Bank name is required";
  }

  if (!/^\d{10}$/.test(form.account_number)) {
    newErrors.account_number = "Account number must be 10 digits";
  }

  if (!form.consent_form) {
    newErrors.consent_form = "Signed consent form is required";
  }

  

  if (form.consent_form) {
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (!allowedTypes.includes(form.consent_form.type)) {
      newErrors.consent_form = "Only JPG, PNG or PDF allowed";
    }

    if (form.consent_form.size > 10 * 1024 * 1024) {
      newErrors.consent_form = "File must not exceed 10MB";
    }
  }

  if (estimatedDisbursement <= 0) {
    newErrors.loan_amount = "Loan amount must be greater than payoff amount";
  }
} else {
    if (form.first_name.trim().length < 2) newErrors.first_name = "Enter a valid first name";
    if (form.last_name.trim().length < 2) newErrors.last_name = "Enter a valid last name";
    if (!form.gender) newErrors.gender = "Please select gender";
    if (!isAdult(form.dob)) newErrors.dob = "Applicant must be at least 18 years old";
    if (!isPhone(form.phone)) newErrors.phone = "Phone number must be 11 digits";
    if (form.other_phone && !isPhone(form.other_phone)) newErrors.other_phone = "Invalid phone number";
    if (!isEmail(form.email)) newErrors.email = "Enter a valid email address";
    if (form.address.trim().length < 10) newErrors.address = "Address is too short";
    if (!form.state_of_origin) newErrors.state_of_origin = "State of origin is required";
    if (form.next_of_kin.trim().length < 3) newErrors.next_of_kin = "Enter next of kin name";
    if (!isPhone(form.nok_phone)) newErrors.nok_phone = "Invalid next of kin phone";
   if (requestedLoanAmount < minAmount) {
  newErrors.loan_amount = `Minimum loan amount is ₦${minAmount.toLocaleString()}`;
}
    if (!form.loan_tenor) newErrors.loan_tenor = "Select loan tenor";
    if (requestedLoanAmount < minAmount || requestedLoanAmount > maxAmount) {
  newErrors.loan_amount = `Loan amount must be between ₦${minAmount.toLocaleString()} and ₦${maxAmount.toLocaleString()}`;
}

if (Number(form.loan_tenor) < minTenure || Number(form.loan_tenor) > maxTenure) {
  newErrors.loan_tenor = `Tenor must be between ${minTenure} and ${maxTenure} months`;
}
    if (!form.bank_name) newErrors.bank_name = "Bank name is required";
    if (!/^\d{10}$/.test(form.account_number)) newErrors.account_number = "Account number must be 10 digits";

    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    requiredUploads.forEach((field) => {
      const file = form[field];
      if (!file) newErrors[field] = "This document is required";
      else if (!allowedTypes.includes(file.type)) newErrors[field] = "Only JPG, PNG or PDF allowed";
      else if (file.size > 10 * 1024 * 1024) newErrors[field] = "File must not exceed 10MB";
    });
  }

  setErrors(newErrors);
  if (Object.keys(newErrors).length) return;

  setSubmitting(true);

  const formData = new FormData();

  formData.append(
  "application_type",
  runningLoanProceed && runningLoan ? "LIQUIDATION_TOPUP" : "NEW_LOAN"
);

  for (const key in form) {
    if (form[key] !== null) formData.append(key, form[key]);
  }

  formData.append("loan_product", selectedProduct);

formData.append("estimated_customer_receives", estimatedCustomerReceives);

formData.append("upfront_fee_rate", upfrontFeeRate);
formData.append("upfront_fee_amount", upfrontFeeAmount);

  if (runningLoanProceed && runningLoan) {
    
    formData.append("existing_loan_id", runningLoan.loan?.id || "");
    formData.append("existing_loan_account", runningLoan.loan?.loan_account || "");
    formData.append("customer_name", runningLoan.loan?.customer_name || "");
   formData.append("outstanding_principal", runningLoanCalc?.principalBalance || 0);
formData.append("one_month_interest", runningLoanCalc?.interestAmount || 0);
formData.append("liquidation_fee", runningLoanCalc?.liquidationFee || 0);
formData.append("paid_months", runningLoanCalc?.paidMonths || 0);
    formData.append("total_principal_to_settle", totalPrincipalToSettle || 0);
    formData.append("estimated_disbursement", estimatedDisbursement || 0);
  }

  try {
    const BASE_URL = process.env.REACT_APP_API_BASE;

    const response = await fetch(`${BASE_URL}/submit_loan.php`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      alert(data.message || "Submission failed");
      return;
    }

    setTrackingId(data.tracking_id);
    setShowSuccessModal(true);
  } catch (error) {
    console.error("Loan submission error:", error);
    alert("Network error. Please try again.");
  } finally {
    setSubmitting(false);
  }
};

  return (


    
    <div className="apply-loan-page">

      {submitting && (
  <div className="submission-overlay">
    <div className="submission-box">
      <div className="submission-spinner"></div>
      <p>Please wait, loan submission processing...</p>
    </div>
  </div>
)}
     <div className="apply-loan-card">

  {/* HEADER */}
  <div className="loan-header">
    <img src={logo} className="loan-logo" alt="Logo" />
    <h2>GMT Technologies Limited</h2>
    <p>Loan Application Form</p>
  </div>

  {/* STEP INDICATOR */}
  <div className="step-indicator">
    <div className={`step ${step === 1 ? "active" : ""}`}>1</div>
    <div className={`step ${step === 2 ? "active" : ""}`}>2</div>
  </div>

  {/* STEP 1 */}
  {step === 1 && (
    <form onSubmit={goToNextStep}>

      <div className="form-group">
        <label>Loan Product</label>
        <select
          className="form-control"
          value={selectedProduct}
          onChange={(e) => setSelectedProduct(e.target.value)}
        >
          <option value="">Select loan product</option>
         {loanProducts.map((item) => (
  <option key={item.product_name} value={item.product_name}>
    {item.product_name}
  </option>
))}
        </select>
      {errors.product && <small className="error-text">{errors.product}</small>}
      </div>

{selectedProductDetails && (
  <div className="product-config-box">
    <div>
      <span>Amount From</span>
      <strong>₦{minAmount.toLocaleString()}</strong>
    </div>

    <div>
      <span>Amount To</span>
      <strong>₦{maxAmount.toLocaleString()}</strong>
    </div>

    <div>
      <span>Tenure From</span>
      <strong>{minTenure} months</strong>
    </div>

    <div>
      <span>Tenure To</span>
      <strong>{maxTenure} months</strong>
    </div>

    <div>
      <span>Interest Rate</span>
      <strong>{interestRate}%</strong>
    </div>
  </div>
)}

      <div className="form-group">
        <label>Bank Verification Number (BVN)</label>
        <input
          name="bvn"
          className="form-control"
          placeholder="Enter 11-digit BVN"
          inputMode="numeric"
          maxLength={11}
          value={form.bvn}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 11) {
              setForm((prev) => ({ ...prev, bvn: value }));
            }
          }}
        />
        {errors.bvn && <small className="error-text">{errors.bvn}</small>}
      </div>

      <div className="form-group">
        <label>National Identification Number (NIN)</label>
        <input
          name="nin"
          className="form-control"
          placeholder="Enter 11-digit NIN"
          inputMode="numeric"
          maxLength={11}
          value={form.nin}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 11) {
              setForm((prev) => ({ ...prev, nin: value }));
            }
          }}
        />
        {errors.nin && <small className="error-text">{errors.nin}</small>}
      </div>

    <button
  type="submit"
  className="btn btn-primary w-100"
disabled={
  checkingLoan ||
  !selectedProduct ||
  form.bvn.length !== 11 ||
  form.nin.length !== 11
}
>
  {checkingLoan ? "Checking loan..." : "Continue"}
</button>

    </form>
  )}

  {/* STEP 2 */}
{step === 2 && (
 <form
  onSubmit={(e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  }}
>

    {/* SUMMARY */}
    <div className="summary-card">
      <strong>Loan Summary</strong>

      <div className="summary-row">
        <span>Product:</span>
        <span>{productConfig.label}</span>
      </div>

      <div className="summary-row">
        <span>BVN:</span>
        <span>{maskNumber(form.bvn)}</span>
      </div>

      <div className="summary-row">
        <span>NIN:</span>
        <span>{maskNumber(form.nin)}</span>
      </div>
    </div>

    {/* PERSONAL DETAILS */}
    <div className="form-grid">

      <div>
        <label className="form-label">First Name</label>
        <input
          name="first_name"
          className="form-control"
          onChange={handleChange}
        />
        {errors.first_name && <small className="error-text">{errors.first_name}</small>}
      </div>

      <div>
        <label className="form-label">Last Name</label>
        <input
          name="last_name"
          className="form-control"
          onChange={handleChange}
        />
        {errors.last_name && <small className="error-text">{errors.last_name}</small>}
      </div>

      <div>
  <label className="form-label">Gender</label>

  <select
    name="gender"
    className="form-control"
    value={form.gender}
    onChange={handleChange}
  >
    <option value="">Select Gender</option>
    <option value="Male">Male</option>
    <option value="Female">Female</option>
  </select>

  {errors.gender && (
    <small className="error-text">{errors.gender}</small>
  )}
</div>

      <div>
        <label className="form-label">Date of Birth</label>
        <input
          type="date"
          name="dob"
          className="form-control"
          onChange={handleChange}
        />
        {errors.dob && <small className="error-text">{errors.dob}</small>}
      </div>

      <div>
        <label className="form-label">Phone Number</label>
        <input
          name="phone"
          className="form-control"
          onChange={handleChange}
        />
        {errors.phone && <small className="error-text">{errors.phone}</small>}
      </div>

      <div>
        <label className="form-label">Other Phone Number</label>
        <input
          name="other_phone"
          className="form-control"
          onChange={handleChange}
        />
        {errors.other_phone && <small className="error-text">{errors.other_phone}</small>}
      </div>

      <div>
        <label className="form-label">Email</label>
        <input
          name="email"
          className="form-control"
          onChange={handleChange}
        />
        {errors.email && <small className="error-text">{errors.email}</small>}
      </div>

    </div>

{selectedProduct && selectedProduct.toUpperCase().includes("SME") && (
  <>
    <hr />
    <h5>Business Details</h5>

    <div className="form-grid">
      <div>
        <label className="form-label">Business Name</label>
        <input
          name="business_name"
          className="form-control"
          onChange={handleChange}
        />
        {errors.business_name && <small className="error-text">{errors.business_name}</small>}
      </div>

      <div>
        <label className="form-label">RC Number</label>
        <input
          name="rc_number"
          className="form-control"
          onChange={handleChange}
        />
      </div>
    </div>

    <div className="mt-3">
      <label className="form-label">Business Address</label>
      <input
        name="business_address"
        className="form-control"
        onChange={handleChange}
      />
      {errors.business_address && <small className="error-text">{errors.business_address}</small>}
    </div>
  </>
)}


    {selectedProduct && selectedProduct.toUpperCase().includes("IPPIS") && (
  <>
    <hr />
    <h5>Employment Details</h5>

    <div className="form-grid">
      <div>
        <label className="form-label">Employer / Ministry</label>
        <input
          name="employer"
          className="form-control"
          onChange={handleChange}
        />
        {errors.employer && <small className="error-text">{errors.employer}</small>}
      </div>

      <div>
        <label className="form-label">IPPIS Number</label>
        <input
          name="ippis_number"
          className="form-control"
          onChange={handleChange}
        />
        {errors.ippis_number && <small className="error-text">{errors.ippis_number}</small>}
      </div>

      <div>
        <label className="form-label">Date of Employment</label>
        <input
          type="date"
          name="date_of_employment"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      <div>
        <label className="form-label">Grade Level</label>
        <input
          name="grade_level"
          className="form-control"
          onChange={handleChange}
        />
      </div>
    </div>
  </>
)}


    {/* ADDRESS */}
    <div className="mt-3">
      <label className="form-label">Home Address</label>
      <input
        name="address"
        className="form-control"
        onChange={handleChange}
      />
      {errors.address && <small className="error-text">{errors.address}</small>}
    </div>

    <div className="mt-3">
      <label className="form-label">State of Origin</label>
      <input
        name="state_of_origin"
        className="form-control"
        onChange={handleChange}
      />
      {errors.state_of_origin && <small className="error-text">{errors.state_of_origin}</small>}
    </div>

    {/* NEXT OF KIN */}
    <div className="form-grid mt-3">

      <div>
        <label className="form-label">Next of Kin</label>
        <input
          name="next_of_kin"
          className="form-control"
          onChange={handleChange}
        />
        {errors.next_of_kin && <small className="error-text">{errors.next_of_kin}</small>}
      </div>

      <div>
        <label className="form-label">Next of Kin Phone</label>
        <input
          name="nok_phone"
          className="form-control"
          onChange={handleChange}
        />
        {errors.nok_phone && <small className="error-text">{errors.nok_phone}</small>}
      </div>

    </div>

    <hr />

    {/* LOAN DETAILS */}
    <div className="form-grid">

      <div>
        <label className="form-label">Loan Amount (₦)</label>
        <input
          name="loan_amount"
          className="form-control"
          onChange={handleChange}
        />
        {errors.loan_amount && <small className="error-text">{errors.loan_amount}</small>}
      </div>

      <div>
        <label className="form-label">Loan Tenor</label>
     <select
  className={`form-control ${errors.loan_tenor ? "is-invalid" : ""}`}
  name="loan_tenor"
  value={form.loan_tenor}
  onChange={handleChange}
>
  <option value="">Select Loan Tenor</option>

{[...Array(maxTenure - minTenure + 1)].map((_, i) => {
  const month = minTenure + i;
    return (
      <option key={month} value={month}>
        {month} {month === 1 ? "Month" : "Months"}
      </option>
    );
  })}
</select>
        {errors.loan_tenor && <small className="error-text">{errors.loan_tenor}</small>}
      </div>

      

            </div>

{!runningLoanProceed && requestedLoanAmount > 0 && selectedProductDetails && (
  <div className="summary-card mt-3">
    <strong>Estimated Disbursement</strong>

    <div className="summary-row">
      <span>Loan Amount</span>
      <span>₦{requestedLoanAmount.toLocaleString()}</span>
    </div>

    <div className="summary-row">
      <strong>Estimated Amount Customer Will Receive</strong>
      <strong>₦{estimatedCustomerReceives.toLocaleString()}</strong>
    </div>
  </div>
)}


{runningLoanProceed && runningLoan && (
  <div className="summary-card mt-3">
    <strong>Top-up Calculation</strong>

    <div className="summary-row">
      <span>New Loan Amount</span>
      <span>₦{Number(requestedLoanAmount || 0).toLocaleString()}</span>
    </div>

   <div className="summary-row">
  <span>Total Payoff Balance</span>
  <span>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Balance After Settlement</span>
  <span>₦{Number(balanceAfterSettlement || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Upfront Fee ({upfrontFeeRate}%)</span>
  <span>₦{Number(upfrontFeeAmount || 0).toLocaleString()}</span>
</div>

    <div className="summary-row">
      <strong>Estimated Amount Customer Will Receive</strong>
      <strong>₦{Number(estimatedDisbursement || 0).toLocaleString()}</strong>
    </div>
  </div>
)}

<hr />
<h5>Bank Details</h5>

<div className="form-grid">

  {/* Bank Name Select */}
  <div>
    <label className="form-label">Bank Name</label>
    <select
      name="bank_name"
      className="form-control"
      value={form.bank_name}
      onChange={handleChange}
    >
      <option value="">Select Bank</option>
      {NIGERIAN_BANKS.map((bank) => (
        <option key={bank} value={bank}>
          {bank}
        </option>
      ))}
    </select>

    {errors.bank_name && (
      <small className="error-text">{errors.bank_name}</small>
    )}
  </div>

  {/* Account Number */}
  <div>
    <label className="form-label">Account Number</label>
    <input
      name="account_number"
      className="form-control"
      inputMode="numeric"
      maxLength={10}
      value={form.account_number}
      onChange={(e) => {
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 10) {
          setForm(prev => ({ ...prev, account_number: value }));
        }
      }}
    />

    {errors.account_number && (
      <small className="error-text">{errors.account_number}</small>
    )}
  </div>

</div>

    <hr />

    {/* UPLOADS */}
    <h5>Required Documents</h5>
   {requiredUploads.map((field) => (
  <div key={field}>
    <UploadField
      label={UPLOAD_LABELS[field]}
      name={field}
      required
     accept="image/jpeg,image/png,application/pdf"
      value={form[field]}
      onChange={handleChange}
      withCamera={IMAGE_UPLOADS.includes(field)}   // 👈 enable camera for ALL uploads
    />

    {errors[field] && (
      <small className="error-text">{errors[field]}</small>
    )}
  </div>
))}

<button
  type="submit"
  className="btn btn-success w-100 mt-4"
  disabled={submitting}
>
  {submitting ? (
    <span className="btn-spinner"></span>
  ) : (
    "Submit Loan Application"
  )}
</button>


  </form>
)}

</div>



{showConfirmModal && (
  <div className="loan-modal-overlay">
    <div className="loan-modal">

      <h4>Confirm Loan Application</h4>

      <p style={{ fontSize: "14px", color: "#475569" }}>
        Please review your application details before submitting.
      </p>

      <div className="summary-card">

        <div className="summary-row">
          <span>Loan Product</span>
          <span>{productConfig?.label}</span>
        </div>

        <div className="summary-row">
          <span>Loan Amount</span>
          <span>₦{Number(form.loan_amount).toLocaleString()}</span>
        </div>

        <div className="summary-row">
          <span>Loan Tenor</span>
          <span>{form.loan_tenor} Months</span>
        </div>



{runningLoanProceed && runningLoan && (
  <>
   <div className="summary-row">
  <span>Total Payoff Balance</span>
  <span>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Balance After Settlement</span>
  <span>₦{Number(balanceAfterSettlement || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Upfront Fee ({upfrontFeeRate}%)</span>
  <span>₦{Number(upfrontFeeAmount || 0).toLocaleString()}</span>
</div>

    <div className="summary-row">
      <strong>Amount Customer Will Receive</strong>
      <strong>₦{Number(estimatedDisbursement || 0).toLocaleString()}</strong>
    </div>
  </>
)}

        <div className="summary-row">
  <span>Bank</span>
  <span>{form.bank_name}</span>
</div>

<div className="summary-row">
  <span>Account</span>
  <span>{form.account_number}</span>
</div>

        <div className="summary-row">
          <span>Applicant</span>
          <span>{form.first_name} {form.last_name}</span>
        </div>

      </div>

      <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
        <button
          type="button"
          className="btn btn-muted w-100"
        onClick={() => {
 setShowConfirmModal(false);

if (runningLoanProceed && runningLoan) {
  setShowRunningLoanModal(true);
}
}}
        >
          Back
        </button>
<button
  type="button"
  className="btn btn-primary w-100"
onClick={() => {
  setShowConfirmModal(false);
  submitLoan();
}}
  disabled={submitting}
>
  {submitting ? (
    <span className="btn-spinner"></span>
  ) : (
    "Confirm & Submit"
  )}
</button>
      </div>

    </div>
  </div>
)}

{showRunningLoanModal && runningLoan && (
  <div className="loan-modal-overlay">
    <div className="loan-modal running-loan-modal">
      <h4>Running Loan Settlement</h4>

      <p style={{ fontSize: "14px", color: "#475569" }}>
        You currently have a running loan. To proceed with a new request, the current loan must be liquidated.
      </p>

      <div className="summary-card">
        <div className="summary-row">
          <span>Customer</span>
          <span>{runningLoan.loan?.customer_name}</span>
        </div>

        <div className="summary-row">
          <span>Loan Account</span>
          <span>{runningLoan.loan?.loan_account}</span>
        </div>

      <div className="summary-row">
  <span>Principal Balance</span>
  <span>₦{Number(runningLoanCalc?.principalBalance || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Interest</span>
  <span>₦{Number(runningLoanCalc?.interestAmount || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Liquidation Fee</span>
  <span>₦{Number(runningLoanCalc?.liquidationFee || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <strong>Total Payoff Balance</strong>
  <strong>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</strong>
</div>

      </div>

  {runningLoanProceed && (
  <div className="form-grid mt-3">

    <div>
      <label className="form-label">Loan Product</label>
      <select
        className={`form-control ${errors.product ? "is-invalid" : ""}`}
        value={selectedProduct}
        onChange={(e) => {
          setSelectedProduct(e.target.value);
          setErrors((p) => ({ ...p, product: "" }));
        }}
      >
        <option value="">Select Loan Product</option>
        {loanProducts.map((item) => (
          <option key={item.product_name} value={item.product_name}>
            {item.product_name}
          </option>
        ))}
      </select>

      {errors.product && (
        <small className="error-text">{errors.product}</small>
      )}
    </div>

    <div>
      <label className="form-label">New Loan Amount (₦)</label>
      <input
        name="loan_amount"
        className="form-control"
        placeholder="Enter new loan amount"
        value={form.loan_amount}
        onChange={(e) => {
  const value = e.target.value.replace(/\D/g, "");

  setForm((prev) => ({
    ...prev,
    loan_amount: value,
  }));
}}
      />
      {errors.loan_amount && <small className="error-text">{errors.loan_amount}</small>}
    </div>

    <div>
      <label className="form-label">Loan Tenor</label>
      <select
        className="form-control"
        name="loan_tenor"
        value={form.loan_tenor}
        onChange={handleChange}
      >
        <option value="">Select Loan Tenor</option>
      {[...Array(maxTenure - minTenure + 1)].map((_, i) => {
  const month = minTenure + i;
          return (
            <option key={month} value={month}>
              {month} {month === 1 ? "Month" : "Months"}
            </option>
          );
        })}
      </select>
      {errors.loan_tenor && <small className="error-text">{errors.loan_tenor}</small>}
    </div>
  </div>
)}

{runningLoanProceed && (
  <>
    <hr />
    <h5>Required Document</h5>

    <UploadField
      label="Signed Consent Form"
      name="consent_form"
      required
      accept="image/jpeg,image/png,application/pdf"
      value={form.consent_form}
      onChange={handleChange}
      withCamera
    />

    {errors.consent_form && (
      <small className="error-text">{errors.consent_form}</small>
    )}
  </>
)}

{runningLoanProceed && (
  <div className="summary-card mt-3">
    <div className="summary-row">
      <span>New Loan Amount</span>
      <span>₦{Number(requestedLoanAmount || 0).toLocaleString()}</span>
    </div>

  <div className="summary-row">
  <span>Total Payoff Balance</span>
  <span>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Balance After Settlement</span>
  <span>₦{Number(balanceAfterSettlement || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Upfront Fee ({upfrontFeeRate}%)</span>
  <span>₦{Number(upfrontFeeAmount || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <strong>Estimated Amount Customer Will Receive</strong>
      <strong>₦{Number(estimatedDisbursement || 0).toLocaleString()}</strong>
    </div>
  </div>
)}

<div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
  <button
    type="button"
    className="btn btn-muted w-100"
    onClick={() => {
      setShowRunningLoanModal(false);
      setRunningLoanProceed(false);
      setStep(1);
    }}
  >
    Back
  </button>

  <button
    type="button"
    className="btn btn-primary w-100"
    onClick={() => {
      if (!runningLoanProceed) {
        setErrors({});
        setRunningLoanProceed(true);
        return;
      }

    const err = {};

    if (!form.bank_name) {
  err.bank_name = "Bank name is required";
}

if (!/^\d{10}$/.test(form.account_number)) {
  err.account_number = "Account number must be 10 digits";
}

if (!selectedProduct) {
  err.product = "Please select a loan product";
}

if (!form.loan_amount) err.loan_amount = "Loan amount is required";
      if (!form.loan_tenor) err.loan_tenor = "Select loan tenor";

      if (!form.consent_form) {
  err.consent_form = "Signed consent form is required";
}

      if (requestedLoanAmount < minAmount || requestedLoanAmount > maxAmount) {
  err.loan_amount = `Loan amount must be between ₦${minAmount.toLocaleString()} and ₦${maxAmount.toLocaleString()}`;
}

if (Number(form.loan_tenor) < minTenure || Number(form.loan_tenor) > maxTenure) {
  err.loan_tenor = `Tenor must be between ${minTenure} and ${maxTenure} months`;
}
      if (estimatedDisbursement <= 0) {
        err.loan_amount = "Loan amount must be greater than payoff amount";
      }

      setErrors(err);
      if (Object.keys(err).length) return;

      setShowRunningLoanModal(false);
      setShowConfirmModal(true);
    }}
  >
    {runningLoanProceed ? "Submit Loan" : "Proceed"}
  </button>
</div>
    </div>
  </div>
)}

      {/* SUCCESS MODAL */}
    {showSuccessModal && (
  <div className="loan-modal-overlay">
    <div className="loan-modal">

      <div className="loan-modal-icon">✓</div>

      <h4>Application Submitted</h4>

    <p style={{ fontSize: "14px", color: "#475569" }}>
  Dear{" "}
  <strong>
    {runningLoanProceed && runningLoan
      ? runningLoan.loan?.customer_name
      : `${form.first_name} ${form.last_name}`}
  </strong>
  , your loan application has been received successfully.
</p>

      {/* =====================
          APPLICATION SUMMARY
      ===================== */}
      <div className="summary-card">

        <div className="summary-row">
          <span>Loan Product</span>
          <span>{productConfig?.label}</span>
        </div>

      <div className="summary-row">
  <span>Loan Amount</span>
  <span>
    ₦{Number(
      String(form.loan_amount || "0").replace(/,/g, "")
    ).toLocaleString()}
  </span>
</div>

        <div className="summary-row">
          <span>Loan Tenor</span>
          <span>{form.loan_tenor} Months</span>
        </div>

        {trackingId && (
          <div className="summary-row">
            <span>Tracking ID</span>

            <span className="tracking-cell">
              <a
                href={`/track-loan/${trackingId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="tracking-link"
              >
                {trackingId}
              </a>

              <button
                type="button"
                className="copy-btn"
                onClick={() => navigator.clipboard.writeText(trackingId)}
                title="Copy tracking ID"
              >
                Copy
              </button>
            </span>
          </div>
        )}
      </div>

      <p style={{ fontSize: "13px", color: "#64748b" }}>
        Our team will review your application and contact you shortly.
      </p>

     <button
  type="button"
  className="btn btn-primary w-100"
  onClick={handleCloseModal}
>
  Close
</button>


    </div>
  </div>
)}

    </div>
  );
}
